export { default } from './ExpansionPanelDetails';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ExpansionPanelDetails/index.js
// module id = 541
// module chunks = 2